import { Column, Row } from 'src/shared/components/Semantic/all'

interface LogoColorDisplayProps {
  colors: Array<{ hex: string; rgb: { r: number; g: number; b: number } }>
  colorCount: number
}

export const LogoColorDisplay = ({ colors }: LogoColorDisplayProps) => {
  if (colors.length === 0) {
    return null
  }

  return (
    <Column className="mt-2 gap-1">
      <div className="flex flex-wrap gap-1.5">
        {colors.map((color, index) => (
          <Row
            key={`${color.hex}-${index}`}
            className="items-center gap-1.5 bg-slate-50 px-1.5 py-1 rounded border border-slate-200"
          >
            <div
              className="w-4 h-4 rounded border border-slate-300 flex-shrink-0"
              style={{ backgroundColor: color.hex }}
            />
            <span className="text-xs font-mono text-slate-700">
              {color.hex.toUpperCase()}
            </span>
          </Row>
        ))}
      </div>
    </Column>
  )
}
